function copyTextToClipboard(text, appendTo) {
	var textArea = document.createElement("textarea");
	textArea.value = text;
	appendTo.appendChild(textArea);
	textArea.focus();
	textArea.select();

	try {
		var successful = document.execCommand('copy');
	} catch (err) {
		console.error('Fallback: Oops, unable to copy', err);

		return false;
	}

	appendTo.removeChild(textArea);

	return successful;
}

function initSharing() {
	//share links
	$('.js-share-link').on('click', function () {
		var link = $(this),
			copiedText = $('#copied-container'),
			timeout = null;

		function getWindowOptions(type) {
			var width,
			height,
			left,
			top;

			if (type == 'twitter') {
				width = 500;
				height = 350;
			} else if (type == 'linkedin') {
				width = 800;
				height = 400;
			}

			left = (window.innerWidth / 2) - (width / 2);
			top = (window.innerHeight / 2) - (height / 2);

			return [
				'resizable,scrollbars,status',
				'height=' + height,
				'width=' + width,
				'left=' + left,
				'top=' + top,
			].join();
		}

		if (link.is('.fb-share')) {
			FB.ui({
				method: 'share',
				href: window.location.href,
			});

			return false;
		} else if (link.is('.twitter-share')) {
			(function () {
				var url = 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(window.location.href),
				win = window.open(url, 'Share on Twitter', getWindowOptions('twitter'));

				win.opener = null;
			}());

			return false;
		} else if (link.is('.linkedin-share')) {
			//$link = 'popUp=window.open(\'http://linkedin.com/shareArticle?mini=true&amp;url=' . urlencode(get_permalink()) . '&amp;title=' . urlencode(get_the_title()) . '\', \'popupwindow\', \'scrollbars=yes,width=800,height=400\');popUp.focus();return false;';
			(function () {
				var url = 'http://linkedin.com/shareArticle?mini=true&url=' + encodeURIComponent(window.location.href),
					win = window.open(url, 'Share on LinkedIn', getWindowOptions('linkedin'));

				win.opener = null;
			}());

			return false;
		} else if (link.is('.copy-share')) {

			let url = window.location.href;
			if (!url.match(/[?&]utm_source=/)) {
				if (url.match(/\?/)) {
					url += '&utm_source=user-shared';
				} else {
					url += '?utm_source=user-shared';
				}
			}

			if (copyTextToClipboard(url, link.closest('div').get(0))) {

				clearTimeout(timeout);
				timeout = null;

				copiedText.css({
					'opacity': '1',
					'height': '30px'
				});

				timeout = setTimeout(function () {
					copiedText.css({
						'height': '',
						'opacity': ''
					});
				}, 3000);
			}

			return false;
		}
	});
};
export { initSharing };
